import React, { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive';

function SliderImageCompony() {
  const isMobile = useMediaQuery({ query: '(max-width: 780px)' });

  return (
    <>
      <div className='c-Slider-Compony'>
      <div className='Slider-Compony'>
          {
          isMobile ?
            <MobileSlider />
          :
          <>
            <div className='oneimage'>
              <img src="image/ads-1.jpg" alt="" />
              <div className='s-c-text-pic pic-1' style={{left: "auto" , right: "5%" , direction:"rtl" , border: "none" , borderRight: "3px solid" , padding: "0" , paddingRight: "29px"}}>
                <p> بورس سنگ و آهن: </p>
                <p className='paragraf'> بهترین منابع و اطلاعات به‌روز در زمینه قیمت‌گذاری و خرید و فروش سنگ و آهن در بازارهای داخلی و بین‌المللی </p>
              </div>
          </div>
          <div className='twoImage'>
              <div className='itemtwoImage'>
                  <img src="image/ads-2.jpg" alt="" />
                  <p className='s-c-text-pic' style={{left: "auto" , right: "5%"}}> مشاوران کمپانی </p>
              </div>
              <div className='itemtwoImage'>
                  <img src="image/ads-3.jpg" alt="" />
                    <p className='s-c-text-pic' style={{left: "auto" , right: "5%"}}> بخش تولید </p>
              </div>
          </div>
          </>
          }
      </div>
      </div>
      <div className='c-vidio-Compony'>
          <div className='vidio-Compony'>
              {/* <Vidio /> */}
              <ObserverVideo />
          </div>
      </div>
    </>
  )
}

export default SliderImageCompony

// function Vidio() {
//   const [isPlaying, setIsPlaying] = useState(false);

//   const handlePlayPause = () => {
//     const video = document.getElementById('video');
//     if (isPlaying) {
//       video.pause();
//     } else {
//       video.play();
//     }
//     setIsPlaying(!isPlaying);
//   };

//   return (
//     <div className="video-container">
//       <video id="video" className="background-video" loop muted>
//         <source src="vidio/6e36e2f8a315304a0d5391508c0d0c1f42918411-720p.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>
//       <div className="overlay">
//         {
//           isPlaying ? 
//           ""
//           :
//           <div>
//             <p>Lorem ipsum dolor sit amet </p>
//             <h1> Lorem ipsum dolor, sit amet consectetur </h1>
//           </div>
//         }
//         <button className={`play-button ${isPlaying ? "" : "isnotPlaying"}`} onClick={handlePlayPause}>
//             <svg  style={{width: "3em" , height: "3em", verticalAlign: "middle",fill: "currentColor" , overflow: "hidden"}} viewBox="0 0 1024 1024" version="1.1"><path d="M658.2 523.8l-151.9 87.7c-31.6 18.2-71-4.6-71-41V395c0-36.4 39.5-59.2 71-41l151.9 87.7c31.5 18.4 31.5 63.9 0 82.1z" fill="#828282"/><path d="M533.2 870c-217.2 0-394-176.7-394-394S316 82 533.2 82s394 176.7 394 394-176.8 394-394 394z m0-737.1C344 132.9 190.1 286.8 190.1 476S344 819.1 533.2 819.1 876.3 665.2 876.3 476 722.4 132.9 533.2 132.9z" fill="#828282"/></svg>
//         </button>
//       </div>
//     </div>
//   );
// }

const ObserverVideo = () => {
  const videoRef = useRef(null);  // ارجاع به iframe
  const [isInView, setIsInView] = useState(false);  // وضعیت مشاهده شدن ویدیو

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setIsInView(entry.isIntersecting);  // وضعیت دیدن بخش ویدیو
      },
      { threshold: 0.5}  // 50% از ویدیو باید در دید باشد
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);  // مشاهده تغییرات وضعیت دیدن ویدیو
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);  // لغو مشاهده
      }
    };
  }, []);

  useEffect(() => {
    const video = document.getElementById('video');
    
    if (isInView) {
        video.play();
    } else {
    video.pause();
    }
  }, [isInView]);

  return (
    <div className="video-container">
      {!isInView && (
        <img
          src="image/pic-back-video.jpg"
          alt="Background"
          className="background-image"
        />
      )}
      <video id="video" className="background-video" loop muted ref={videoRef}>
        <source src="vidio/6e36e2f8a315304a0d5391508c0d0c1f42918411-720p.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

const images  = [
  {
      ID: 1 ,
      src:"image/cat-2-1.jpg",
      title: "لورم ایپسوم متنی ساختگی 1",
      discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. A natus quisquam consectetur est tempora sit laborum 1",
  },
  {
      ID: 2 ,
      src:"image/cat-2-2.jpg",
      title: "لورم ایپسوم متنی ساختگی  2",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 2",
  },
  {
      ID: 3 ,
      src:"image/cat-2-3.jpg",
      title: "لورم ایپسوم متنی ساختگی  3",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 3",
  },
  {
      ID: 4 ,
      src:"image/cat-2-4.jpg",
      title: "لورم ایپسوم متنی ساختگی  4",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 4",
  },
  {
      ID: 5 ,
      src:"image/cat-2-5.jpg",
      title: "لورم ایپسوم متنی ساختگی  5",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 5",
  },
  {
      ID: 6 ,
      src:"image/cat-2-6.jpg",
      title: "لورم ایپسوم متنی ساختگی  6",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 6",
  },
  {
      ID: 7 ,
      src:"image/cat-2-7.jpg",
      title: "لورم ایپسوم متنی ساختگی  7",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 7",
  },
  {
      ID: 8 ,
      src:"image/cat-2-8.jpg",
      title: "لورم ایپسوم متنی ساختگی  8",
      discription: "لورم ایپسوم متنی ساختگی و بدون معنی است که معمولاً به عنوان متن پرکننده در طراحی گرافیک، طراحی وب و انتشارات چاپی استفاده می‌شود. 8",
  },
];

function MobileSlider() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);
    const sliderRef = useRef(null);
    const slides = [...images, ...images, ...images]; // تکرار اسلایدها برای بی‌نهایت بودن

    let startX = 0;
    let endX = 0;
    let isSwiping = false; // برای تشخیص سوایپ واقعی

    const calculateSlideWidth = () => {
        const slide = sliderRef.current.children[0];
        const slideWidth = slide.offsetWidth;
        const gap = parseFloat(window.getComputedStyle(slide).marginRight);
        return slideWidth + gap;
    };

    const slideNext = () => {
        setIsTransitioning(true);
        if (currentSlide < images.length * 2 - 1) {
            setCurrentSlide(currentSlide + 1);
        } else {
            // جابجایی نرم به اولین اسلاید (بدون انیمیشن)
            setTimeout(() => {
                setIsTransitioning(false); // انیمیشن را غیرفعال می‌کنیم
                setCurrentSlide(images.length); // به اولین نسخه از تصاویر برمی‌گردیم
            }, 300); // زمان انیمیشن (بسته به CSS شما)
        }
    };

    const slidePrev = () => {
        setIsTransitioning(true);
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        } else {
            // جابجایی نرم به آخرین اسلاید (بدون انیمیشن)
            setTimeout(() => {
                setIsTransitioning(false);
                setCurrentSlide(images.length - 1);
            }, 300);
        }
    };

    // مدیریت حرکت انگشت برای اسلاید
    const handleTouchStart = (e) => {
        startX = e.touches[0].clientX;
        isSwiping = false; // هنگام شروع تاچ، فرض کنیم که هنوز سوایپ نشده است
    };

    const handleTouchMove = (e) => {
        endX = e.touches[0].clientX;
        const swipeDistance = startX - endX;

        // اگر فاصله بیشتر از 10 پیکسل باشد، سوایپ فعال می‌شود
        if (Math.abs(swipeDistance) > 10) {
            isSwiping = true; // سوایپ فعال است
        }
    };

    const handleTouchEnd = () => {
        if (!isSwiping) {
            // اگر سوایپ فعال نشده، یعنی کاربر فقط کلیک کرده و نیازی به تغییر اسلاید نیست
            return;
        }

        const swipeDistance = startX - endX;
        const threshold = 50; // میزان حداقل فاصله برای تشخیص سوایپ

        if (swipeDistance > threshold) {
            // سوایپ به چپ: به اسلاید بعدی برو
            slideNext();
        } else if (swipeDistance < -threshold) {
            // سوایپ به راست: به اسلاید قبلی برو
            slidePrev();
        }
    };

    useEffect(() => {
        const offset = -calculateSlideWidth() * currentSlide;
        sliderRef.current.style.transform = `translateX(${offset}px)`;
        sliderRef.current.style.transition = isTransitioning ? 'transform 0.3s ease' : 'none';
    }, [currentSlide, isTransitioning]);

    useEffect(() => {
        const handleResize = () => {
            const offset = -calculateSlideWidth() * currentSlide;
            sliderRef.current.style.transform = `translateX(${offset}px)`;
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [currentSlide]);

    useEffect(() => {
        // تنظیم تایمر برای اجرای خودکار اسلایدها
        const intervalId = setInterval(slideNext, 4000); // تغییر هر 5 ثانیه

        return () => {
            clearInterval(intervalId); // پاک کردن تایمر هنگام unmount
        };
    }, [currentSlide]);

    return (
        <div className="slider-container"
             onTouchStart={handleTouchStart}
             onTouchMove={handleTouchMove}
             onTouchEnd={handleTouchEnd}>
            <div className="slider" ref={sliderRef}>
                {slides.map((item, index) => (
                    <div key={index} className="slide">
                        <img src={item.src} alt="" />
                        <div className='c-textimageSlider'></div>
                        <div className='textimageSlider'>
                            <h3>{item.title}</h3>
                            <p>{item.discription}</p>
                        </div>
                    </div>
                ))}
            </div>
            <button className="prev" onClick={slidePrev}>&#10094;</button>
            <button className="next" onClick={slideNext}>&#10095;</button>
        </div>
    );
}
